import { Col, Image, Row } from "antd";

const mediaBase =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/77-unveiling-of-portrait-at-the-TCK-OBA-secretariat";

const images = [
  {
    src: `${mediaBase}/nahil+talking+to+people.jpeg`,
    alt: "Nahil Wijesuriya speaking with guests at the TCK OBA Secretariat",
  },
  {
    src: `${mediaBase}/nahil-talking-to-people.jpeg`,
    alt: "Nahil Wijesuriya with guests at the portrait unveiling",
  },
  {
    src: `${mediaBase}/oba%3Dpresents-board.jpeg`,
    alt: "TCK OBA presentation board",
  },
  {
    src: `${mediaBase}/portrait.jpeg`,
    alt: "Portrait of Nahil Wijesuriya unveiled at the TCK OBA Secretariat",
  },
];

export const UnveilingPortraitTCKOBA = () => {
  const imageStyle = {
    aspectRatio: "4 / 3",
    objectFit: "cover",
    width: "100%",
  };

  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="unveiling-of-portrait-at-the-tck-oba-secretariat">
          Unveiling of Portrait at the TCK OBA Secretariat
        </h1>
      </div>

      <Row gutter={[16, 24]}>
        <Col xs={24}>
          <p>
            The Trinity College Kandy Old Boys&apos; Association marked the
            unveiling of a portrait of Nahil Wijesuriya at the TCK OBA
            Secretariat.
          </p>
          <div
            style={{
              background: "#000",
              margin: "24px auto",
              maxWidth: "900px",
            }}
          >
            <video
              controls
              playsInline
              preload="metadata"
              style={{ display: "block", height: "auto", width: "100%" }}
            >
              <source src={`${mediaBase}/nahil-unvieling.mp4`} type="video/mp4" />
              Your browser does not support the video element.
            </video>
          </div>
        </Col>

        {images.map((image) => (
          <Col xs={24} md={12} key={image.src}>
            <Image
              alt={image.alt}
              preview={{ mask: "View image" }}
              src={image.src}
              style={imageStyle}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};